import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { uiActualizarResultatCatAction } from '../../../actions/ui';

// ─── Paleta de colores de categorías ─────────────────────────────────────────
const CAT_COLORS = [
  'var(--color-1)',
  'var(--color-2)',
  'var(--color-3)',
  'var(--color-4)',
  'var(--color-5)',
  'var(--color-6)',
  'var(--color-7)',
  'var(--color-8)',
  'var(--color-9)',
];

// ─── Color semáforo según resultado ──────────────────────────────────────────
const getSemaforColor = (val) => {
  const n = parseFloat(val) / 100;
  if (n >= 0.60) return { color: 'var(--color-success)', label: 'Bueno'    };
  if (n >= 0.40) return { color: 'var(--color-warning)', label: 'Regular'  };
  return           { color: 'var(--color-danger)', label: 'A mejorar' };
};

// ─── Barra de progreso horizontal ────────────────────────────────────────────
const BarraProgreso = ({ valor, color }) => {
  const pct = Math.min(100, Math.max(0, parseFloat(valor) || 0));
  return (
    <div className="res-progress-bar-bg">
      <div
        className="res-progress-bar-fill"
        style={{ width: `${pct}%`, backgroundColor: color }}
      />
    </div>
  );
};


export const ResultatsCategoria = () => {
  const dispatch = useDispatch();
  const [t]      = useTranslation("generic");

  const { ui, configFormulario } = useSelector(state => state);

  const [rows,    setRows]    = useState([]);
  const [catName, setCatName] = useState('');
  const [catNum,  setCatNum]  = useState(1);

  useEffect(() => {
    if (ui.resultatCat === true && configFormulario.resultatsCategoria) {
      const cat = configFormulario.resultatsCategoria;
      const num = cat.NumCat;
      setCatNum(num);
      setCatName(t(`formulario.titleCat${num}`));

      const newRows = [];
      for (let i = 1; i <= cat.numResultados; i++) {
        const raw = cat[`resultat${i}`];
        const pct = raw % 1 === 0 ? raw * 100 : parseFloat((raw * 100).toFixed(2));
        const pregTexto = t(`Categoria${num}.preg${i}`, { defaultValue: '' });
        newRows.push({ name: i, resultado: pct, pregunta: pregTexto });
      }
      setRows(newRows);
    }
  }, [ui]);

  const handleClose = () => dispatch(uiActualizarResultatCatAction(false));

  const catColor     = CAT_COLORS[(catNum - 1) % CAT_COLORS.length];
  const media        = rows.length > 0
    ? (rows.reduce((acc, r) => acc + r.resultado, 0) / rows.length).toFixed(1)
    : null;

  if (!ui.resultatCat) return null;

  return (
    <>
      {/* Overlay */}
      <div className="res-modal-overlay" onClick={handleClose} />

      {/* Panel centrado */}
      <div className="res-modal-panel">

        {/* Header con color de categoría */}
        <div className="res-modal-header" style={{ backgroundColor: catColor }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <p className="res-modal-header-label">Detalle de categoría</p>
              <h2 className="res-modal-header-title">{catName}</h2>
            </div>
            <button
              className="res-modal-close-btn"
              onClick={handleClose}
              aria-label="Cerrar"
            >×</button>
          </div>

          {media && (
            <div className="res-modal-media-badge">
              <span>Media de la categoría:</span>
              <span style={{ fontSize: 15, fontWeight: 800 }}>{media}%</span>
            </div>
          )}
        </div>

        {/* Cuerpo scrollable */}
        <div className="res-modal-body">
          {rows.length === 0 ? (
            <p style={{ color: '#9ca3af', textAlign: 'center', padding: '32px 0' }}>
              No hay datos disponibles.
            </p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {rows.map((row) => {
                const sem = getSemaforColor(row.resultado);
                return (
                  <div key={row.name} className="res-row">
                    {row.pregunta && (
                      <p className="res-row-question">{row.pregunta}</p>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <BarraProgreso valor={row.resultado} color={sem.color} />
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                        <span className="res-semaforo-value" style={{ color: sem.color }}>
                          {row.resultado}%
                        </span>
                        <span
                          className="res-semaforo-badge"
                          style={{
                            backgroundColor: sem.bg,
                            color: sem.color,
                            borderColor: sem.color + '44',
                          }}
                        >
                          {sem.label}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="res-modal-footer">
          <button
            onClick={handleClose}
            style={{
              padding: '10px 24px', borderRadius: 10,
              border: `1.5px solid ${catColor}`,
              backgroundColor: catColor, color: '#fff',
              fontSize: 14, fontWeight: 700, cursor: 'pointer',
              transition: 'opacity 0.2s',
            }}
            onMouseEnter={e => (e.currentTarget.style.opacity = '0.85')}
            onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
          >
            Cerrar
          </button>
        </div>
      </div>
    </>
  );
};